// extracted by mini-css-extract-plugin
export default {"signedInFooter":"SuccessFooter_signedInFooter__FrlVi"};